import { getStatusColor, CompletionBadge } from '@/components/ui/metrics'
import type { MonthPlanFact } from '@/features/history/types'

interface AverageCheckRowProps {
  label: string
  metric: MonthPlanFact
  formatValue: (v: number) => string
}

export function AverageCheckRow({ label, metric, formatValue }: AverageCheckRowProps) {
  return (
    <tr className="bg-muted/20 border-b border-border hover:bg-muted/30 transition-colors">
      <td className="p-2 pl-12 text-xs text-muted-foreground italic">↳ {label}</td>
      <td className="p-2 text-right font-mono text-xs">{formatValue(metric.plan)}</td>
      <td className={`p-2 text-right font-mono text-xs ${getStatusColor(metric.completion, metric.plan)}`}>
        {formatValue(metric.fact)}
      </td>
      <td className="p-2 text-right font-mono text-xs">{formatValue(metric.plan)}</td>
      <td className={`p-2 text-right font-mono text-xs font-semibold ${getStatusColor(metric.completion, metric.plan)}`}>
        {formatValue(metric.fact)}
      </td>
      <td className={`p-2 text-center ${getStatusColor(metric.completion, metric.plan)}`}>
        <CompletionBadge metric={metric} />
      </td>
    </tr>
  )
}
